module.exports = __webpack_public_path__ + "img/run4.b2c5b24f.png";